<template>
  <div v-if="visible" class="video-popup">
    <div class="popup-content">
      <div class="popup-header">
        <div style="display: flex;align-items: center;">
          <span>{{ title }}</span>
          <div v-if="showDetail" class="detail" style="margin-left: 5px;" @click="showCCTV">详情</div>
        </div>
        <span class="close-btn" @click="handleClose">×</span>
      </div>
      <div v-if="type === 'video'" class="video-container">
        <video ref="videoPlayer" controls autoplay muted>
          <source :src="videoUrl" type="video/mp4">
          您的浏览器不支持视频播放
        </video>
      </div>
      <div v-else-if="type === 'image'" class="image-container">
        <img :src="resolveImage(imageUrl)" alt="详情图片" />
      </div>
      <div v-else class="info-container">
        <div class="info-content">
          <div class="info-item">
            <div class="info-label">位置：</div>
            <div class="info-value">{{ info.location || '暂无' }}</div>
          </div>
          <div class="info-item">
            <div class="info-label">时间：</div>
            <div class="info-value">{{ info.time || '暂无' }}</div>
          </div>
          <div class="info-item">
            <div class="info-label">状态：</div>
            <div class="info-value">{{ info.status || '暂无' }}</div>
          </div>
          <div class="info-item">
            <div class="info-label">描述：</div>
            <div class="info-value">{{ info.description || '暂无' }}</div>
          </div>
          <div v-if="info.imageUrl" class="info-item">
            <div class="info-label">图片：</div>
            <div class="info-value">
              <img :src="info.imageUrl" alt="详情图片" class="info-image" @click="showFullImage = true" />
            </div>
          </div>
        </div>
      </div>
      
      <!-- 全屏图片预览 -->
      <div v-if="showFullImage" class="fullscreen-image" @click="showFullImage = false">
        <img :src="info.imageUrl" alt="详情图片" />
        <div class="close-fullscreen">×</div>
      </div>

      <!-- 添加水质信息详情展示 -->
      <div v-if="info && info.details" class="info-details">
        <div class="details-list">
          <div class="details-item" v-for="(item, index) in info.details" :key="index">
            <div class="detail-label">{{ item.label }}:</div>
            <div class="detail-value">{{ item.value }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <CCTV
      :visible="cctvVisible"
      @update:visible="cctvVisible = $event"
    />
</template>

<script>
import CCTV from '@/page/camera/CCTV.vue'

export default {
  name: 'VideoPopup',
  components: {
    CCTV
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '监控视频'
    },
    type: {
      type: String,
      default: 'video'
    },
    videoUrl: {
      type: String,
      default: ''
    },
    imageUrl: {
      type: String,
      default: ''
    },
    info: {
      type: Object,
      default: () => ({})
    },
    showDetail: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showFullImage: false,
      cctvVisible: false
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
      // 停止视频播放
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause()
        this.$refs.videoPlayer.currentTime = 0
      }
      // 重置全屏图片状态
      this.showFullImage = false
    },
    showCCTV(){
      this.cctvVisible = true
    }
  }
}
</script>

<style scoped>
.video-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-content {
  background: #171e21;
  border-radius: 8px;
  padding: 16px;
  width: 640px;
  max-width: 90vw;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
  position: relative;
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  color: #fff;
  font-size: 18px;
}

.close-btn {
  cursor: pointer;
  font-size: 24px;
  color: #999;
  transition: color 0.3s;
}

.close-btn:hover {
  color: #fff;
}

.video-container {
  width: 100%;
  aspect-ratio: 16/9;
  background: #000;
  overflow: hidden;
  border-radius: 4px;
}

.image-container {
  width: 100%;
  text-align: center;
  background: #000;
  border-radius: 4px;
  overflow: hidden;
}

.image-container img {
  max-width: 100%;
  max-height: 400px;
  object-fit: contain;
}

video {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.detail {
  font-size: 0.7rem;
  color: #fff;
  right: 1rem;
  color: rgb(0, 255, 185);
  cursor: pointer;
}

.info-container {
  padding: 16px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  color: #fff;
  max-height: 60vh;
  overflow-y: auto;
}

.info-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-item {
  display: flex;
  align-items: flex-start;
}

.info-label {
  width: 80px;
  color: #999;
  flex-shrink: 0;
}

.info-value {
  flex: 1;
  word-break: break-all;
}

.info-image {
  max-width: 100%;
  max-height: 200px;
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.3s;
}

.info-image:hover {
  transform: scale(1.02);
}

.fullscreen-image {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
  cursor: pointer;
}

.fullscreen-image img {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
}

.close-fullscreen {
  position: absolute;
  top: 20px;
  right: 30px;
  color: white;
  font-size: 30px;
  cursor: pointer;
}

/* 水质详情样式 */
.info-details {
  margin-top: 10px;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.details-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
}

.details-item {
  display: flex;
  align-items: center;
}

.detail-label {
  color: #a0c8e2;
  font-size: 14px;
  margin-right: 8px;
}

.detail-value {
  color: #fff;
  font-weight: 500;
}
</style>